<template>
    <div class="loginStyle">
        <div class="re login_img_div">
            <div class="ab login_img_box">
                <img src="../assets/img/T261030_qb.png" draggable="false" style="width: 611px;height: 108px;" alt="">
                <p class="link_p">让每一个连接更具价值</p>
                <img src="../assets/img/T261030.png" draggable="false" style="width: 100%;height: 100%;" alt="">
            </div>
            <div class="tips_con">愿君砥砺前行，赏尽两岸花开</div>
        </div>
        <div class="loginRight">
            <!--  密码登录   -->
            <div class="loginRight_div">
                <h4 class="loginRight_H2"><span style="font-weight: 700;font-size: 26px;vertical-align: middle;">CRM、国内、国际卡 </span>内部账户登录平台</h4>
                <p class="loginRight_Tips">Tips：本入口仅支持内部账号登录，不支持客户账户登录</p>
                <el-steps :active="active" simple>
                    <el-step title="账户密码" icon="el-icon-edit"></el-step>
                    <el-step title="登录平台" icon="el-icon-upload"></el-step>
                </el-steps>
                <div v-if='active == 1'>
                    <el-form :model="PsdLoginType" ref="PsdLoginType" :rules="rules" size="medium" style="width:98%; margin:6px auto 0;" class="iptStyle">
                        <el-form-item prop="accountName">
                            <el-input  v-model="PsdLoginType.accountName" maxlength="50"  placeholder="请输入用户名" >
                                <img src="../assets/img/YH.svg" slot="prefix" draggable="false" alt="用户名" class="item_cont">
                            </el-input>
                        </el-form-item >
                        <el-form-item prop="password">
                            <el-input show-password v-model="PsdLoginType.password" maxlength="40" placeholder="请输入密码" clearable>
                                <img src="../assets/img/MM.svg" slot="prefix" draggable="false" alt="密码" class="item_cont">
                            </el-input>
                        </el-form-item>
                        <el-form-item class=" re" prop="verifyCode">
                            <el-input v-model="PsdLoginType.verifyCode" placeholder="请输入验证码" :maxlength='4' clearable style="width:276px;">
                                <img src="../assets/img/YZM.svg" slot="prefix" draggable="false" alt="验证码" class="item_cont">
                            </el-input>
                            <span @click="getCode()" class="ab cursors code_items" >
                                <img :src="codeSrc" draggable="false" alt="验证码" >
                            </span>
                        </el-form-item>
                        <el-form-item style="margin-top:26px;">
                            <el-button  
                                type="primary" 
                                v-if="!isClick" @click.native.prevent="codeLogin('PsdLoginType')"  
                                @keyup.enter.native="codeLogin('PsdLoginType')" 
                                class="item_btns"
                            >
                                登&nbsp;&nbsp;&nbsp;录
                            </el-button>
                            <el-button  
                                type="info" 
                                v-if="isClick"  
                                class="item_btns" 
                                disabled="disabled"
                            >
                                登&nbsp;&nbsp;&nbsp;录
                            </el-button>
                            <span @click="ScanCodeLogin" class="cursors" style="color:#888;"><i class="el-icon-full-screen"></i>&nbsp;&nbsp;企业微信扫码登录</span>
                        </el-form-item>
                    </el-form>
                </div>
                <div style="margin-top: 16px;" v-else>
                    <ul style="margin: 0px;padding: 0px;">
                        <li v-for="item in platformList" :key="item.sysCode" @click="goPlat(item)"  class="cursors">
                            <span style="display: flex; align-items: center;">
                                <img draggable="false" v-if="item.sysCode == 'SYSTEM_1'" src="../assets/img/T250314_1.png" style="width: 28px;" />
                                <img draggable="false" v-else-if="item.sysCode == 'SYSTEM_2'" src="../assets/img/T250314_2.png" style="width: 27px;" />
                                <img draggable="false" v-else src="../assets/img/T250314_3.png" style="width: 27px;" />
                                <strong style="font-size: 16px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{platform.find(ele=>ele.sysCode == item.sysCode).sysName}} 平台</strong>
                            </span>
                            <i class="el-icon-arrow-right"></i>
                        </li>
                    </ul>
                    <el-button type="warning" size="small"  style="width:100%;font-size: 15px;margin-top: 12px;" @click="resetLogin" >
                       <p class="out_P">
                            <i class="el-icon-switch-button" style="font-size: 18px;font-weight: 700;"></i>&nbsp;
                            退出，重新登录
                       </p>
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>    
 var axios = require('axios')
import { mapActions } from "vuex";
export default {
    name:'login',
    data() {
        return {
            isClick:false,
            codeSrc:"", //图形验证码路径
            rules:{
                accountName: [
                    { required: true, message: '请输入用户名', trigger: ["blur", "change"]},
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: ["blur", "change"]},
                ],
                verifyCode: [
                    { required: true, message: '请输入验证码', trigger: ["blur"]},
                    { pattern: /^[a-zA-Z0-9]+$/, message: "由大小写字母，数字组成" },
                    { min: 4, message: "长度为4个字符",trigger: ["blur"]}
                ]
            },
            // 密码登录
            PsdLoginType:{
                accountName:'',
                password:"",
                verifyCode:'',
                vtoken:""
            },
            title:'',
            nmb:120, // 短信验证码时间
            timer:null,
            active:1,
            platformList:[],
            platform:[
                {sysCode:'SYSTEM_1',sysName:'CRM'},
                {sysCode:'SYSTEM_2',sysName:'国际卡管理'},
                {sysCode:'SYSTEM_3',sysName:'国内卡管理'},
                {sysCode:'SYSTEM_4',sysName:'CRM_GY'},
            ],
            token:""
        };
    },
    methods: {
        ...mapActions([
            'saveInfo','saveJumpParams'
        ]),
        // 密码登录
        // 来到第二步展示可登录的平台
        codeLogin(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loginSend();
                    this.isClick = true;
                } else {
                    return false;
                }
            });
        },
        //获取密码登录验证码
        getCode(){
            this.PsdLoginType.verifyCode = '';
            axios.defaults.withCredentials = true;
            axios({
                method: 'get',
                url: this.API.Sso + 'getVtoken',
                headers: {'Accept-Language': 'zh-CN'}
            })
            .then(resd => {
                if(resd.data.code == 200){
                    this.PsdLoginType.vtoken = resd.data.data;
                    this.IsCode(resd.data.data);
                }else{
                   console.log('呵呵呵。。。报错了');
                }
            })
        },
        //判断密码登录验证码是否正确
        IsCode(vtoken){
            axios.defaults.withCredentials = true;
            axios({
                method: 'post',
                url: this.API.Sso + 'getCode?vtoken=' + vtoken,
                transformRequest: [function (data) {
                    let ret = ''
                    for (let it in data) {
                        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
                    }
                    return ret
                }],
                responseType: "arraybuffer",
                headers:{
                    'Content-Type':'application/x-www-form-urlencoded',
                    'Accept-Language': 'zh-CN'
                }
            })
            .then(res => {
                this.codeSrc = 'data:image/jpeg;base64,' + btoa(new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
            })
        },
        // 获取第二步可登录的平台
        loginSend(){
            let obj = {};
            Object.assign(obj,this.PsdLoginType);
            obj.password = this.$md5(obj.password);
            axios.defaults.withCredentials = true;
            axios({
                method: 'post',
                url: this.API.Sso + 'admin/pwd/signIn',
                data: obj,
                headers: {'Accept-Language': 'zh-CN'}
            })
            .then(resd => {
                if(resd.data.code == 200){
                    this.active = 2;
                    let { systems, token } = resd.data.data;
                    this.token = token;
                    this.platformList = systems.map(ele => ({sysCode:ele.sysCode}));
                    // 存储cookie
                    document.cookie = "JointLogin="+ this.token +";path=/;"
                    document.cookie = "JointParams="+ JSON.stringify(this.platformList) +";path=/;"
                }else{
                    this.isClick = false;
                    this.getCode(); //重新获取验证码
                    this.$alert(resd.data.message, '温馨提示', { dangerouslyUseHTMLString: true,type: 'warning' });
                }
            }).catch(err => {
                this.isClick = false;
                this.getCode(); //重新获取验证码
            })
        },
        // 选择平台(进入平台)
        goPlat(val){
            axios({
                method: 'get',
                url: this.API.Sso + `admin/without/skip/${val.sysCode}`,
                headers:{
                    'Authorization': this.token,
                    'Accept-Language': 'zh-CN'
                }
            })
            .then(res => {
                if(res.data.code == 200){
                    let { sysCode, authToken } = res.data.data;
                    if(sysCode == 'SYSTEM_3'){
                        // 国内卡 平台
                        if(this.$common.getCookie('CardPageKey')){
                            this.$alert('国内物联网卡平台已经在另一个窗口中打开！', '操作提示', {
                                confirmButtonText: '确定',
                                type: 'warning',
                                roundButton: true
                            });
                        }else{
                            window.open(res.data.data.jumpUrl + "?authToken=" + authToken, "_blank");  
                        }
                    }else{
                        // crm 平台 / 国际卡
                        window.open(res.data.data.jumpUrl + "?param=" + JSON.stringify({sysCode, authToken}), "_blank");
                    }
                }else{
                    // 登录失败时
                    // 清除cookie
                    this.resetToken();
                }
            }).catch(err => {
                // 登录失败时
                // 清除cookie
                this.resetToken();
            })
        },
        // 重新登录
        // 从第二步返回第一步
        resetLogin(){
            axios({
                method: 'get',
                url: this.API.Sso + `admin/without/logout`,
                headers:{
                    'Authorization': this.token,
                    'Accept-Language': 'zh-CN'
                }
            })
            .then(res => {
                // 清除cookie
                this.resetToken();
            }).catch(err => {
                // 清除cookie
                this.resetToken();
            })
        },
        // 清除token返回第一步
        resetToken(){
            this.isClick = false;
            document.cookie = 'JointLogin=' + this.$common.getCookie('JointLogin') + ';path=/;expires=Thu,01 Jan 1970 00:00:00 GMT'; // 退出清除token cookie
            document.cookie = 'JointParams=' + this.$common.getCookie('JointParams') + ';path=/;expires=Thu,01 Jan 1970 00:00:00 GMT'; // 退出清除token cookie
            this.active = 1;
            this.getCode();
        },
        // 心跳用于检测token是否过期
        heartbeat(token, callback){
            axios({
                method: 'get',
                url: this.API.Sso + `admin/heartbeat`,
                headers:{
                    'Authorization': token,
                    'Accept-Language': 'zh-CN'
                }
            })
            .then(res => {
                if(res.data.code == 200){
                    callback && callback();
                }else{
                    // 清除cookie
                    this.resetToken();
                }
            }).catch(err => {
                // 清除cookie
                this.resetToken();
            })
        },
        ScanCodeLogin(){
            window.location.href = 'https://login.work.weixin.qq.com/wwlogin/sso/login?login_type=CorpApp&appid=wwc2ee68a7254ef58b&agentid=1000029&redirect_uri=https%3A%2F%2Fsso.tibiot.com%2FWXLogin&state=STATE';
        }
    },
    created(){
        if(this.$route.query.param){
            // 联合登录跳转
            let param = JSON.parse(this.$route.query.param);
            axios({
                method: 'get',
                url: this.API.IgwIar + `admin/internal/skip/get/context?toSystemCode=${param.sysCode}&accessToken=${param.authToken}`,
                headers: { 
                    'Authorization': param.token,
                    'Accept-Language': 'zh-CN'
                }
            })
            .then(res => {
                // 清除url 的路径参数
                let url = window.location.href;
                window.location.href = url.slice(0, url.indexOf('?'))
                if(res.data.code == 200){
                    this.active = 2;
                    let { systems, token } = res.data.data;
                    this.token = token;
                    this.platformList = systems.map(ele => ({sysCode:ele.sysCode}));
                    document.cookie = "JointLogin="+ this.token +";path=/;"
                    document.cookie = "JointParams="+ JSON.stringify(this.platformList) +";path=/;"
                }else{
                    // 清除cookie
                    this.resetToken();
                }
            }).catch(err => {
                // 清除cookie
                this.resetToken();
            })
        }else if(this.$common.getCookie('JointLogin')){
            // 登录表单提交后
            // 判断是否登录过
            // 登录过会存token
            this.token = this.$common.getCookie('JointLogin');
            // 通过心跳检测后
            // 来到第二步
            this.heartbeat(this.token,()=>{
                this.active = 2;
                this.platformList = JSON.parse(this.$common.getCookie('JointParams')) ;
            })
        }else{
            this.getCode(); //重新获取验证码
        }
        // 注册回车事件
        document.onkeydown = e =>{
            if(window.event == undefined){
                var key = e.keyCode;
            }else{
                var key = window.event.keyCode;
            }
            if(key == 13){
                this.codeLogin('PsdLoginType');
            }
        }
        
    },
};
</script>
<style scoped>
    .loginStyle{
        height: 100%;
        display: flex;
    }
    .loginleft{
        width: 400px;
        border-radius: 8px 0px 0px 8px;
        overflow: hidden;
    }
    .Left_top{
        height: 78px;
        line-height: 78px;
        font-size: 18px;
        color:#8E96A2;
    }
    .loginRight{
        position: relative;
    }
    .loginRight_div{
        width: 430px;
        position: absolute;
        top:42%;
        left: 50%;
        transform: translate(50%,-50%);
    }
    .logo_img_ico{
        width:20px;
        height:20px;
        padding-top:1px;
    }
    .re{
        position: relative;
    }
    .ab{
        position: absolute;
    }
    .cursors{
        cursor: pointer;
    }
    li{
        list-style: none;
        border: 1px solid #e9e9e9;
        padding: 14px 12px;
        margin-bottom: 7px;
        border-radius: 9px;
        display: flex;
        align-items: center;
        color: #333;
        justify-content: space-between;
    }
    li:hover{
        border-color: #007dff;
        color: #3e92eb;
        background: #c4d9ff33;
    }
    .item_cont{
        width:14px;
        height:14px;
        padding:11px 0px 0px 3px;
    }
    .code_items{
        display:inline-block;
        width:130px; 
        height:34px;
        border:1px solid #cdcdcd;
        border-radius:3px;
        overflow:hidden;
        right:0px;
    }
    .item_btns{
        font-size:18px;
        width:100%;
    }
    .link_p{
        color: #ffffff;
        font-size: 18px;
        text-align: center;
        margin: -20px 0px 102px;
    }
    .tips_con{
        position:fixed;
        bottom: 12px;
        font-size:14px;
        color:#eff8f8;
        padding-left: 253px;
    }
    .login_img_div{
        width:730px;
        text-align: center;
        background: #030917;
        border-radius: 0px 19px 19px 0px;
        overflow: hidden;
    }
    .login_img_box{
        width:730px;
        height:450px; 
        top:36%;
        left: 50%;
        transform: translate(-50%,-50%);
    }
    .loginRight_H2{
        text-align: center;
        margin-bottom: 0px;
        font-size: 18px;
        color: #000;
    }
    .loginRight_Tips{
        text-align: center;
        margin-bottom: 36px;
        color:#777;
        font-size: 13px;
        margin-top: 3px;
    }
    .out_P{
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0px;
    }
</style>
<style>
.el-steps--simple{
    background: none;
}
.el-step.is-simple .el-step__title{
    font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// src/login/login.vue